import { MockPolicyId } from "../mockPolicies";
import { insuranceBillPastDue } from "../builders/createInsuranceBill";
import { cigPastDueBill } from "../builders/createCigBill";
import { getHdc1Dot0Membership } from "../builders/getHdc1Dot0Membership";
import { getMockPolicies } from "../builders/getMockPolicies";
import { legacyUsVipMember } from "../mockMembers";

import { MockPersona } from "./mockPersonas.types";

const usPolicies: MockPolicyId[] = ["def456"];

export const buzzLightyear: MockPersona = {
  key: "buzzLightyear",
  name: "Buzz Lightyear",
  description: "🇺🇸 | Single policy with no broker | HDC 1.0 VIP | Bill past due | Auto pay | Email Verified",
  emailVerified: true,
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [
          cigPastDueBill({
            productNumber: usPolicies[0],
            id: "1",
            amount: 123456,
          }),
        ],
      },
      policies: {
        usa: getMockPolicies(...usPolicies),
        canada: [],
      },
    },
    hdc: {
      fetch1Dot0Membership: getHdc1Dot0Membership({ ProductCode: "USMEMBVIP" }),
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "buzz@lightyear.com",
            firstName: "Buzz",
            middleName: "",
            lastName: "Lightyear",
            mailingAddress: {
              line1: "123 Apartment Rd",
              line2: "Room #456",
              city: "Los Angeles",
              state: "CA",
              postalCode: "90001",
              country: "USA",
            },
            preferredPhone: "7381234567",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000004",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: legacyUsVipMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [
            insuranceBillPastDue({
              policyNumber: usPolicies[0],
              id: "1",
              amount: 12345600,
              formattedAmount: "$123,456",
            }),
          ],
          outstandingBalance: 1,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
